import { FormStructureForm } from "components/Forms/FormStructureForm/FormStructureForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerTitle } from "components/UI/DrawerTitle/DrawerTitle";
import { useDrawer } from "hooks/useDrawer";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { FormStructureType } from "types/enums";
import { DrawerId } from "types/models.ts";

interface FormStructureDrawerProps {
    type: FormStructureType;
    onSubmit: () => void;
}

export const FormStructureDrawer: FC<FormStructureDrawerProps> = ({ type, onSubmit }) => {
    const { t } = usePaldockTranslation("drawers.form-structure");
    const id = DrawerId.FormStructure;
    const drawerUtils = useDrawer();

    const titleByType =
        type === FormStructureType.Lead
            ? t("titles.lead")
            : type === FormStructureType.User
                ? t("titles.user")
                : t("titles.default");

    const handleSubmit = () => {
        onSubmit();
        drawerUtils.hide(id);
    };

    return (
        <Drawer drawerId={id} title={<DrawerTitle mainTitle={titleByType} />}>
            <FormStructureForm onSubmit={handleSubmit} type={type} />
        </Drawer>
    );
};